import React from 'react';
import { Box } from 'grommet';
import SHDText from '@ui/Text/SHDText';
import SHDButton from '@ui/Button/SHDButton';
import { LiveStreamSettingsModal } from './LiveStreamSettingsModal';
import SHDThemeOverride from '@ui/ThemeOverride/SHDThemeOverride';
import SHDFooter from '@ui/Footer/SHDFooter';

interface HowToAndErrorModalProps {
  headerText: string;
  title: string;
  subtitle?: string;
  onClose: () => void;
  isError: boolean;
  htmlContent?: string;
}

const HowToAndErrorModal: React.FC<HowToAndErrorModalProps> = ({
  headerText,
  title,
  subtitle,
  onClose,
  isError,
  htmlContent,
}) => {
  return (
    <SHDThemeOverride>
      <LiveStreamSettingsModal
        headerText={headerText}
        title={title}
        onCloseModal={onClose}
        goBack={!isError ? onClose : undefined}
      >
        <Box
          fill="vertical"
          style={{
            display: 'flex',
            flexDirection: 'column',
            height: '100%',
          }}
        >
          {isError && subtitle && (
            <Box
              style={{
                marginTop: -20,
                position: 'absolute',
              }}
            >
              <SHDText style="footnote">{subtitle}</SHDText>
            </Box>
          )}

          <Box
            flex={{ grow: 1 }}
            overflow="auto"
            pad={{ horizontal: 'medium', vertical: 'small' }}
            style={{
              padding: '16px',
              boxSizing: 'border-box',
            }}
          >
            {htmlContent && (
              <div
                style={{
                  fontFamily: 'Arial, sans-serif',
                  fontSize: '14px',
                  color: '#183247',
                  lineHeight: '1.5',
                  overflowWrap: 'break-word',
                  wordBreak: 'break-word',
                }}
                dangerouslySetInnerHTML={{ __html: htmlContent }}
              />
            )}
          </Box>
        </Box>
        <SHDFooter>
          <SHDButton label="Done" primary onClick={onClose} />
        </SHDFooter>
      </LiveStreamSettingsModal>
    </SHDThemeOverride>
  );
};

export default HowToAndErrorModal;
